export function calculatePsqiResults(psqiData) {
  const {
    psqiPreg001,
    psqiPreg002,
    psqiPreg003,
    psqiPreg004,
    psqiPreg005a,
    psqiPreg005b,
    psqiPreg005c,
    psqiPreg005d,
    psqiPreg005e,
    psqiPreg005f,
    psqiPreg005g,
    psqiPreg005h,
    psqiPreg005i,
    psqiPreg005k,
    psqiPreg006,
    psqiPreg007,
    psqiPreg008,
    psqiPreg009,
  } = psqiData;

  // Calidad del sueño (Componente 1)
  const calidadDelSueno = psqiPreg006 === undefined || psqiPreg006 === '' ? '' : parseInt(psqiPreg006) || 0;

  // Latencia del sueño (Componente 2)
  const psqiPreg002Value = psqiPreg002 === undefined || psqiPreg002 === '' ? '' :
    psqiPreg002 >= 0 && psqiPreg002 <= 15
      ? 0
      : psqiPreg002 >= 16 && psqiPreg002 <= 30
      ? 1
      : psqiPreg002 >= 31 && psqiPreg002 <= 60
      ? 2
      : psqiPreg002 > 60
      ? 3
      : '';

  const latenciaDelSueno = 
    psqiPreg002Value === '' || psqiPreg005a === undefined || psqiPreg005a === '' ? '' :
    (() => {
      const totalSum2And5a = (psqiPreg002Value || 0) + (parseInt(psqiPreg005a) || 0);
      return totalSum2And5a < 1
        ? 0
        : totalSum2And5a >= 1 && totalSum2And5a <= 2
        ? 1
        : totalSum2And5a >= 3 && totalSum2And5a <= 4
        ? 2
        : totalSum2And5a >= 5 && totalSum2And5a <= 6
        ? 3
        : '';
    })();

  // Duración del sueño (Componente 3)
  const duraciónDelSueno = 
    psqiPreg004 === undefined || psqiPreg004 === '' ? '' :
    psqiPreg004 < 5
      ? 3
      : psqiPreg004 >= 5 && psqiPreg004 < 6
      ? 2
      : psqiPreg004 >= 6 && psqiPreg004 <= 7
      ? 1
      : psqiPreg004 > 7
      ? 0
      : '';

  // Eficiencia del sueño (Componente 4)
  const eficienciaDelSueno = 
    psqiPreg001 === undefined || psqiPreg001 === '' || 
    psqiPreg003 === undefined || psqiPreg003 === '' || 
    psqiPreg004 === undefined || psqiPreg004 === '' ? '' :
    (() => {
      const date1 = new Date(`2000-01-01T${psqiPreg001}`);
      const date2 = new Date(`2000-01-01T${psqiPreg003}`);
      if (date1 > date2) {
        date1.setDate(date1.getDate() - 1);
      }
      const diffInMilliseconds = Math.abs(date2 - date1);
      const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
      const psqiComp4EficSue = Math.trunc(
        (parseInt(psqiPreg004) / diffInHours) * 100
      );
      return psqiComp4EficSue < 65
        ? 3
        : psqiComp4EficSue >= 65 && psqiComp4EficSue <= 74
        ? 2
        : psqiComp4EficSue >= 75 && psqiComp4EficSue <= 84
        ? 1
        : psqiComp4EficSue >= 85
        ? 0
        : '';
    })();

  // Despertares nocturnos (Componente 5)
  const despertaresNocturnos = 
    psqiPreg005b === undefined || psqiPreg005b === '' ||
    psqiPreg005c === undefined || psqiPreg005c === '' ||
    psqiPreg005d === undefined || psqiPreg005d === '' ||
    psqiPreg005e === undefined || psqiPreg005e === '' ||
    psqiPreg005f === undefined || psqiPreg005f === '' ||
    psqiPreg005g === undefined || psqiPreg005g === '' ||
    psqiPreg005h === undefined || psqiPreg005h === '' ||
    psqiPreg005i === undefined || psqiPreg005i === '' ? '' :
    (() => {
      const totalSumPregPsqi005 =
        (parseInt(psqiPreg005b) || 0) +
        (parseInt(psqiPreg005c) || 0) +
        (parseInt(psqiPreg005d) || 0) +
        (parseInt(psqiPreg005e) || 0) +
        (parseInt(psqiPreg005f) || 0) +
        (parseInt(psqiPreg005g) || 0) +
        (parseInt(psqiPreg005h) || 0) +
        (parseInt(psqiPreg005i) || 0) +
        (parseInt(psqiPreg005k) || 0); // Si psqiPreg005k no está definida, se suma 0
      return totalSumPregPsqi005 <= 0
        ? 0
        : totalSumPregPsqi005 >= 1 && totalSumPregPsqi005 <= 9
        ? 1
        : totalSumPregPsqi005 >= 10 && totalSumPregPsqi005 <= 18
        ? 2
        : totalSumPregPsqi005 >= 19 && totalSumPregPsqi005 <= 27
        ? 3
        : '';
    })();

  // Uso de medicamentos (Componente 6)
  const usoDeMedicamentos = psqiPreg007 === undefined || psqiPreg007 === '' ? '' : parseInt(psqiPreg007) || 0;

  // Disfunción diurna (Componente 7)
  const disfunciónDiurna = 
    psqiPreg008 === undefined || psqiPreg008 === '' ||
    psqiPreg009 === undefined || psqiPreg009 === '' ? '' :
    (() => {
      const totalSum8And9 = (parseInt(psqiPreg008) || 0) + (parseInt(psqiPreg009) || 0);
      return totalSum8And9 <= 0
        ? 0
        : totalSum8And9 >= 1 && totalSum8And9 <= 2
        ? 1
        : totalSum8And9 >= 3 && totalSum8And9 <= 5
        ? 2
        : totalSum8And9 >= 5 && totalSum8And9 <= 6
        ? 3
        : '';
    })();

  // Puntuación global - solo calcula si todos los componentes tienen valor
  const puntuacionGlobal = 
    calidadDelSueno === '' ||
    latenciaDelSueno === '' ||
    duraciónDelSueno === '' ||
    eficienciaDelSueno === '' ||
    despertaresNocturnos === '' ||
    usoDeMedicamentos === '' ||
    disfunciónDiurna === '' ? '' :
    calidadDelSueno +
    latenciaDelSueno +
    duraciónDelSueno +
    eficienciaDelSueno +
    despertaresNocturnos +
    usoDeMedicamentos +
    disfunciónDiurna;

  return {
    calidadDelSueno,
    latenciaDelSueno,
    duraciónDelSueno,
    eficienciaDelSueno,
    despertaresNocturnos,
    usoDeMedicamentos,
    disfunciónDiurna,
    puntuacionGlobal,
  };
}